module.exports = __webpack_public_path__ + "img/oneDesRed.f10adb91.jpg";